import { CLEAR_SELECTED_STRUCT_ITEM } from "../../../../enums/Request/leader.requests.types";

export const clearSelectedStructItemAction = () => {
    return {
        type: CLEAR_SELECTED_STRUCT_ITEM,
    };
};